import aframe from "aframe"

import Stats from "stats-js"

console.log(Stats)

aframe.registerComponent("stats-grabber", {

    schema: {
        default: false,
    },

    init: function () {
        // console.log(this.el.components.stats.stats)

        // this.stats = new Stats()
        // this.stats.showPanel(1)
        // document.body.appendChild(this.stats.dom)
    },

    tick: function(d, dT) {
        // this.stats.update()

        // console.log(dT)
    }
})


// WEBPACK FOOTER //
// ./src/components-aframe/statsGrabber.js